import EmailLink from "../components/EmailLink";
import styles from "./Barrierefreiheit.module.css";

export default function Accessibility() {
  return (
    <main
      id="main-content"
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: 1.6,
      }}
    >
      <h1 className={styles.title}>Erklärung zur Barrierefreiheit</h1>

      <p>
        Die Organisator:innen des <strong>DUOday Hannover</strong> setzen sich
        dafür ein, diese Website barrierefrei zugänglich zu gestalten. Ziel ist
        es, allen Menschen den gleichberechtigten Zugang zu Informationen und
        Angeboten rund um den DUOday zu ermöglichen.Wir verbessern
        kontinuierlich die Benutzerfreundlichkeit für alle und wenden die
        entsprechenden Standards (WCAG 2.2, BITV und der Norm EN 301 549) für
        die Zugänglichkeit an.
      </p>

      <h2>Geltungsbereich</h2>
      <p>
        Diese Erklärung zur digitalen Barrierefreiheit gilt für die Website
        <strong> https://duoday-hannover.de/</strong> sowie alle zugehörigen
        Inhalte und Unterseiten, die im Rahmen des DUOday bereitgestellt werden.
      </p>

      <h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
      <p>
        Der Webauftritt ist mit den technischen Anforderungen gemäß der Web
        Content Accessibility Guidelines (WCAG) 2.2 und der
        Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) derzeit nicht
        vollständig vereinbar. Diese Barrierefreiheitserklärung bezieht sich auf
        die duoday-hannover.de.
        <strong>
          Web Content Accessibility Guidelines (WCAG) 2.2, der BITV 2.0 sowie
          der Norm EN 301 549
        </strong>
      </p>

      <p>
        Einige Inhalte sind noch nicht vollständig barrierefrei. Wir arbeiten
        kontinuierlich daran, bestehende Barrieren zu identifizieren und zu
        reduzieren.
      </p>

      <h2>Maßnahmen zur Unterstützung der Barrierefreiheit</h2>
      <p>
        Diese Website verwendet die Software Eye-Able® der Firma Web Inclusion
        GmbH, um Nutzern*innen eine barriere-reduzierte Ansicht der visuellen
        Inhalte zu ermöglichen. Eye-Able® hilft, die Website an die
        individuellen Bedürfnisse der Besucher*innen anzupassen. Zum
        Funktionsumfang von Eye-Able® gehören:
      </p>

      <ul>
        <li>adaptive Schriftvergrößerung,</li>
        <li>eine freie Anpassung der Farbkontraste,</li>
        <li>eine Vorlesefunktion mit integrierter Tastatur-Navigation,</li>
        <li>ein Blaufilter,</li>
        <li>ein Nachtmodus,</li>
        <li>eine Sofortansicht zur Verbindung mehrerer Funktionen,</li>
        <li>eine Kompensation von Farbschwächen sowie</li>
        <li>
          weitere Funktionen für eine individuelle Ansicht der Website wie ein
          größerer Mauszeiger, serifenlose Schrift sowie das Ausblenden von
          Bildern, Animationen und Ton
        </li>
      </ul>
      <p>
        Zur Bedienung kann das zugehörige Menü über einen Klick auf das Eye-
        Able®-Icon oder mit dem Tastaturkürzel „ALT + 1“ geöffnet werden. Alle
        Funktionen können auch mit der Tastatur gesteuert werden (Anleitung über
        „ALT + F1“). Mehr Informationen finden Sie unter: www.eye-able.com
      </p>
      <p>
        Eye-Able ist BITV/WCAG konform getestet. Eine Zusammenfassung des
        Prüfberichts kann unter folgendem Link eingesehen werden:{" "}
        <a
          href="https://services.eye-able.com/wp-content/uploads/2023/07/BITV-Report-Eye-Able%C2%AE-1.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Eye-Able Prüfbericht
        </a>
      </p>
      <p>
        Diese Erklärungen wurden am 10.06.2025 erstellt und am 14.07.2025
        aktualisiert. Die Erklärung wurde mithilfe der Eye-Able® Technologie der
        Web Inclusion GmbH erstellt. Mehr Informationen zur Web Inclusion GmbH
        sind unter https://eye-able.com/ zu finden. Die Web Inclusion GmbH hat
        alle maschinell überprüfbaren Prüfschritte durchlaufen. Außerdem wurden
        auch manuelle Tests durchgeführt.
      </p>

      <h2>Rückmeldung und Kontaktangaben</h2>
      <p>
        Sie haben eine Anmerkung oder einen Hinweis zu Barrieren auf dieser
        Webseite? Bitte nehmen Sie mit uns Kontakt auf. Wir erklären Ihnen,
        welche Barrieren bestehen. Sie können sich informieren, welche Ausnahmen
        wir gemacht haben. Wir beantworten Ihre Fragen schnellstmöglich,
        spätestens jedoch innerhalb der gesetzlichen Frist von sechs Wochen.
        Vielen Dank für Ihr Feedback. Sie können uns über folgende Adresse
        kontaktieren:
      </p>

      <address>
        <p>
          <strong>DUOday Hannover</strong>
          <br />
          enercity AG
          <br />
          Glockseeplatz 1
          <br />
          30169 Hannover
        </p>
      </address>
              <p>
          <strong>Email:</strong>{" "}
          <EmailLink
            user="duoday-hannover"
            domain="enercity.de"
            className={styles.link}
            label="duoday-hannover@enercity.de"
          />
        </p>

        <p>
          <strong>Telefon:</strong>{" "}
          <a href="tel:+495114303016" className={styles.link}>+49 511 430 3016</a>
        </p>

        <p>
          <strong>Handy:</strong>{" "}
          <a href="tel:+491622595194" className={styles.link}>+49 162 2595194</a>
        </p>
    </main>
  );
}
